import {
  GET_EMPLOYER_JOBS_PENDING,
  GET_EMPLOYER_JOBS_SUCCESS,
  GET_EMPLOYER_JOBS_ERROR,
} from "../../actions/job";

const initialState = {
  pending: false,
  jobs: [],
  error: null,
};

const getEmployersJobs = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYER_JOBS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_EMPLOYER_JOBS_SUCCESS:
      return {
        ...state,
        pending: false,
        jobs: action.payload.jobs,
        totalJobs: action.payload.total,
      };
    case GET_EMPLOYER_JOBS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default getEmployersJobs;
